module.exports = __webpack_public_path__ + "static/media/assignedLoadingNumbers.38011531.png";